<template>
  <main class="main-content">
    <section class="section --banner">
      <div class="banner">
        <div class="banner__bg">
          <!-- <img :src="`http://a34.madpay.com${newData.banner}`" /> -->
          <img :src="`https://www.jiashengvac.com${newData.banner}`" />
          <!-- <img :src="`http://admin.jiashengvac.com${newData.banner}`" /> -->
        </div>
        <div class="banner__content container-fluid">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ newData.title }}</h1>
             <p class="banner__text">{{ newData.intro }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container-fluid">
        <div class="g-content" v-html="newData.content"></div>
<!--        <div class="content-img">-->
<!--          <img src="../assets/imgs/test2.png" />-->
<!--        </div>-->

        <div class="row mt-4 mt-md-2">
          <div class="col-12" style="width: 50%;cursor: pointer !important; " @click="goPage('News')">
            <div class="white-box__links">
              <a class="white-box__link --b">
                <strong class="white-box__link-label">
                  {{ $t("i18n.company") }}
                </strong>
                <h4 class="white-box__link-text">
                  {{ $t("i18n.backNews") }}
                </h4>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {getNesDetail} from "../api/api.js";
export default {
  name: "NewsDetail",

  data() {
    return {
      form: {},
      newData: {},
    };
  },

  created() {
    let data = this.$route.params.form;
    if (!data) {
      this.form = JSON.parse(localStorage.getItem("thisNew"));
    } else {
      this.form = data;
      localStorage.setItem("thisNew", JSON.stringify(this.form));
    }
    this.search();
    // this.goTop();
  },
  mounted () {
    this.goTop()
  },
  methods: {
    search() {
      getNesDetail({id: this.form.id}).then(res => {
        if (res && res.data && res.data.data) {
          this.newData = res.data.data;
          this.newData.content = this.newData.content.replace(/\<img/gi, '<img style="width:100%;height:auto" ');
          // this.newData.image = "http://a34.madpay.com/"+ this.newData.image;
          this.newData.image = "https://www.jiashengvac.com/"+ this.newData.image;
          // this.newData.image = "http://admin.jiashengvac.com/"+ this.newData.image;
        } else {
          this.newData = {};
        }
      })
    },
    goPage(path) {
      this.$router.push(path)
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // setTimeout(()=>{
      //   document.querySelector('#topDom').scrollIntoView({
      //     behavior: 'smooth'
      //   })
      // },100)
    }
  },
};
</script>

<style scoped>
.section.--banner,
.section.--main-slider {
  padding: 0;
  max-width: 100vw;
  overflow-x: hidden;
}
.banner {
  height: 64rem;
  align-items: center;
  display: flex;
}
.banner__bg {
  position: absolute;
  width: 100%;
  height: 64rem;
}
.banner__bg {
  z-index: 1;
}

.banner__bg img {
  max-width: 100%;

  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}
img {
  max-width: 100%;
}
.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-size: 4rem;
  letter-spacing: -0.084rem;
  line-height: 6rem;
  margin-bottom: 2rem;
  padding-right: 2rem;
  color: #ffffff;
  font-weight: 500;
}
.banner__text {
  margin-top: 3rem;
  font-size: 2.1rem;
  letter-spacing: -0.022rem;
  line-height: 4rem;
  padding-right: 2rem;
  color: #ffffff;
}
.g-content {
  margin-top: 10rem;
  font-family: Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 2.4rem;
  color: #231815;
  line-height: 5rem;
}
.content-img {
  width: 100%;
  border-radius: 0.4rem;
  padding-bottom: 10rem;
}
.content-img img {
  max-width: 100%;
}

.white-box__links {
  background: #fff;
  display: flex;
  min-height: 8rem;
  overflow: hidden;
  margin-bottom: 6rem;
}
.white-box__link {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 5rem;
  border: 0.2rem solid #e6e6e6;
  border-radius: 1rem;
  transition: all .2s ease-in-out;
  width: 40%;
}


.g-content .white-box__link-label, .white-box__link-label {
  font-weight: 500;
  font-size: 1.3rem;
  color: black;
  letter-spacing: .035rem;
  text-transform: uppercase;
  display: block;
  line-height: 1.7rem;
  margin-bottom: 1rem;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text, .white-box__link-text {
  font-weight: 500;
  font-size: 3rem;
  color: #990099;
  letter-spacing: -.015rem;
  line-height: 3.2rem;
  position: relative;
  padding-right: 1.5rem;
  margin: 0;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text:after, .white-box__link-text:after {
  content: "";
  position: absolute;
  padding-right: 2rem;
  right: 0;
  width: 0.8rem;
  height: 1.4rem;
  top: 1.2rem;
  background: url(../assets/imgs/arrow-right.png) no-repeat 50%;
  transition: all .2s ease-in-out;

}

@media (max-width: 768px) {
  .g-content .white-box__link-text:after, .white-box__link-text:after {
    content: "";
    background: url('');
  }
  .white-box__links{
    width: 100%;
  }
  .white-box__link{
    width: 100%;
  }

  .banner__title {
    font-size: 16px;
    font-weight: bold;
  }

  .banner__text {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/NewsDetail.vue